export const StringConstant = {
    REGION_NA: "NA",
    REGION_EU: "EU",
    REGION_FE: "FE",
    REGION_IN: "IN",
    AVERY_PRINTER: "AVERY_PRINTER",
    APP_TITLE: "Induct",
    LOCAL_STORAGE_URL_KEY: "stationBuddy-induct-url"
}


// WEBPACK FOOTER //
// ./src/components/utils/StringConstant.js